import React from 'react';
import { motion } from 'framer-motion';

const MAFinalCTA = () => {
  return (
    <section className="relative py-32 bg-brand-black overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1579532537598-459ecdaf39cc?q=80&w=2070&auto=format&fit=crop" 
          alt="Abstract Architecture" 
          className="w-full h-full object-cover opacity-10 grayscale" 
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-transparent to-brand-black"></div>
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-6xl font-bold tracking-tighter text-white mb-8">
            Navigate Complex Transactions <br /> 
            <span className="text-brand-gold">with Confidence</span>
          </h2>
          <p className="text-xl text-gray-400 font-light mb-12">
            Discretionary advisory for high-stakes mergers, acquisitions, and strategic restructuring.
          </p>
          <a href="mailto:admin@whiteknightgc.com" className="inline-block px-12 py-6 bg-brand-gold text-white font-bold text-lg tracking-widest uppercase hover:bg-white hover:text-brand-black transition-all duration-500 shadow-2xl shadow-brand-gold/20">
            Speak with an Advisor
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default MAFinalCTA;